// src/constants/featureColors.js
//
// Curated per-type colors for the FEATURES-tab vector_assets layers, so the map
// reads as a legend. v1 is frontend-only (no DB): these are the DEFAULTS;
// session overrides live in useFeatureColorStore and win over the palette.
//
// EFFECTIVE COLOR = override ?? palette ?? fallback.
// One color per type drives all geometry (point circle / line / polygon
// fill+outline) — see VectorFeatureLayers.

export const FEATURE_COLOR_FALLBACK = "#94a3b8"; // slate-400, for unmapped types

export const FEATURE_PALETTE = {
  // hazards / combustion — warm
  flare:            "#f97316", // orange
  spill_perimeter:  "#ef4444", // red
  // water — blue
  frac_pond:        "#38bdf8", // sky
  // infrastructure — lines
  road:             "#9ca3af", // gray
  pipeline:         "#eab308", // amber
  flowline:         "#fb923c", // light orange
  fence:            "#b08968", // earthy brown
  fence_access:     "#d2b48c", // tan
  // point equipment
  power_pole:       "#a78bfa", // violet
  separator:        "#2dd4bf", // teal
  storage_tank:     "#22d3ee", // cyan
  tank_battery:     "#0ea5e9", // sky-600
  valve:            "#f472b6", // pink
  well_head:        "#34d399", // green
  // sites / pads
  facility_site:    "#818cf8", // indigo
  well_pad:         "#16f2d4", // accent-teal (matches PadLayer — pads render there)
  // detected
  detected_well:    "#1f9dff", // accent-blue
};

export function paletteColor(type) {
  return FEATURE_PALETTE[type] ?? FEATURE_COLOR_FALLBACK;
}

// Effective color for a type given the current session overrides map.
export function effectiveFeatureColor(type, overrides) {
  return (overrides && overrides[type]) || FEATURE_PALETTE[type] || FEATURE_COLOR_FALLBACK;
}
